import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// components

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

// views

import Dashboard from "views/admin/Dashboard.js";
import Appointment from "views/admin/Appointment";
import Message from "views/admin/Message";
import { useSelector } from "react-redux";
import Testimonial from "views/admin/Testimonial";





export default function Admin() {
  const { token } = useSelector((state) => state.auth);

  if (!token) {
    return <Redirect to="/login" />;
  }

  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <AdminNavbar />
        {/* Header */}
        <HeaderStats />
        <div className="px-4 md:px-10 mx-auto w-full -m-24">
          <Switch>
            <Route path="/admin/dashboard" exact component={Dashboard} />
            <Route path="/admin/appointment" exact component={Appointment} />
            <Route path="/admin/message" exact component={Message} />
            <Route path="/admin/testimonial" exact component={Testimonial} />
            <Redirect from="/admin" to="/admin/dashboard" />
          </Switch>
          <FooterAdmin />
        </div>
      </div>
    </>
  );
}
